<template>
  <div :class="componentClass">
      <h2>{{config.label}}</h2>
      <div v-if="!items[config.type] || items[config.type].items.length <= 0">
        <span style="font-style:italic">No <span style="text-transform:lowercase">{{config.label}}</span></span>
      </div>
      
      <div v-for="(item, index) in items[config.type].items" :key="index">
          <ModalDelete v-bind:tagItem="item"/>
      </div>
  </div>
</template>

<script>
import ModalDelete from '../components/ModalWithDelete';
export default {
  components: {
      ModalDelete
  },
  props: ['config'],
  name: 'Tags',
  computed:{
      componentClass(){
          return "control-container " + this.config.class
      },
      items() {
        return this.$store.state.modalWithDeleteItems
      }
  }
}
</script>

<style scoped>
h2{
    text-transform: capitalize;
}
</style>